import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { Box, Button, Pagination, PaginationItem, Grid } from '@mui/material';

import {
  DataGrid,
  // gridPaginationRowCountSelector,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
// import { setHistory } from '../../../redux/history';
import moment from 'moment';
// import { resetHistory } from '../../../redux/history';
// import FailModal from '../common/FailModal';
import ProjectSubSubComponent from './ProjectSubSubCompoent';

const CustomGrid2 = styled(Grid)({
  marginBottom: '12px',
});

const ProjectSubCompoent = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const user = useSelector((state) => state.user.userData);
  const [rowSelectionModel, setRowSelectionModel] = useState();
  // const [openFailModal, setOpenFailModal] = useState(false);

  // const modalHandleClose = () => {
  //   setOpenFailModal(false);
  // };

  const column = [
    {
      sortable: true,
      field: '_id',
      headerName: 'No',
      flex: 0,
      width: 120,
      editable: false,
    },
    {
      field: 'groupName',
      headerName: 'Organization',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        return params;
      },
    },
    {
      field: 'dataTarget',
      headerName: 'Date Target',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      valueGetter: (params) => {
        return params ? params.name : '';
      },
    },
    {
      field: 'dataType',
      headerName: 'Data Type',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      valueGetter: (value) => {
        return value ? value.name : ''; // { _id, name } 객체에서 name 추출
      },
    },
    { field: 'researchDirector', headerName: 'Research Director', headerAlign: 'center', align: 'center', flex: 0.5 },
    { field: 'sampleCount', headerName: 'Sample Count', headerAlign: 'center', align: 'center', flex: 0.5 },
    {
      field: 'publisherName',
      headerName: 'Publisher',
      flex: 0.4,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        return params ? params : '';
      },
    },
    {
      field: 'modifyDate',
      headerName: 'Last Updated',
      flex: 0.7,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (value, row) => {
        let dateValue;

        // 1. row.modifyDate
        if (value) {
          dateValue = value;
        }
        // 2. row.createDate (fallback)
        else if (row.createDate) {
          dateValue = row.createDate;
        }
        // 3. 둘 다 없음
        else {
          return '-';
        }

        return moment(dateValue).format('YYYY.MM.DD HH:mm');
      },
    },
  ];

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    //filtering total row
    // console.log(useGridSelector(apiRef, gridPaginationRowCountSelector));
    return (
      <Pagination
        color="primary"
        variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        // @ts-expect-error
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }

  const columnVisibilityModel = React.useMemo(() => {
    if (rowSelectionModel === undefined) {
      return {
        publisherName: true,
      };
    }
    return {
      publisherName: false,
    };
  }, [rowSelectionModel]);
  // useEffect(() => {
  //   console.log(rowSelectionModel);
  // }, [rowSelectionModel]);

  return (
    <div>
      <Grid container>
        <CustomGrid2 size={12}>
          <div>
            <div style={{ float: 'left', fontSize: '20px', paddingLeft: '8px' }}>
              <b>{props.rows ? props.rows.length : ''}</b> Result(s)
            </div>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddIcon />}
              style={{
                height: '100%',
                textTransform: 'none',
                float: 'right',
              }}
              onClick={() => {
                // setOpenPost(true)
                navigate('/project/addpost', { state: { group: state === null ? user.group : state.group } });
              }}
            >
              데이터 추가
            </Button>
          </div>
        </CustomGrid2>
        <CustomGrid2 size={rowSelectionModel === undefined ? 12 : 8} container>
          <Box
            style={{
              height: '720px',
              maxHeight: '720px',
              width: '100%',
              marginTop: 8,
            }}
          >
            <DataGrid
              sx={{ height: '100%' }}
              getRowId={(row) => row['_id']}
              rowHeight={36}
              // getRowHeight={() => 'auto'}
              columns={column}
              rows={props.rows}
              onRowSelectionModelChange={(ids) => {
                if (ids.length > 0) {
                  const selectedIDs = new Set(ids);
                  const selectedRowData = props.rows.filter((row) => selectedIDs.has(row._id));
                  setRowSelectionModel(selectedRowData[0]._id);
                  // dispatch(setHistory({ idx: [...selectedIDs][0], historyData: selectedRowData[0] }));
                  // console.log(selectedRowData[0]._id);
                  // handleSetSelectedRow(selectedRowData[0]._id);
                }
              }}
              initialState={{
                pagination: { paginationModel: { pageSize: 50 } },
              }}
              slots={{
                pagination: CustomPagination,
              }}
              pageSizeOptions={[5, 10, 20, 50]}
              pagination
              disableColumnSelector
              columnVisibilityModel={columnVisibilityModel}
              showCellVerticalBorder
            />
          </Box>
        </CustomGrid2>
        {props.rows && (
          <CustomGrid2
            size={rowSelectionModel === undefined ? 12 : 4}
            sx={{
              // 그리드 아이템 자체가 콘텐츠 높이만큼 커지도록
              height: 'fit-content', // 또는 'auto'
              // 레이아웃 깨짐 방지
              overflow: 'visible',
            }}
          >
            {rowSelectionModel !== undefined && (
              <Grid
                sx={{
                  width: '100%',
                  height: '100%',
                  padding: '8px',
                  display: 'inline-flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                  overflowY: 'scroll',
                }}
              >
                <ProjectSubSubComponent
                  rowId={rowSelectionModel}
                  rowClear={setRowSelectionModel}
                  reloadList={props.reloadList}
                />
              </Grid>
            )}
          </CustomGrid2>
        )}
      </Grid>
    </div>
  );
};

export default ProjectSubCompoent;
